import React, { useRef } from 'react';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';

function CustomSelect({ schema, formData, onChange }) {
  const onValueChange = (option) => {
    if (Array.isArray(option)) {
      const newValue = option.length ? option.map((option) => option.value) : '';
      onChange(newValue);
    } else {
      const newValue = option ? option.value : '';
      onChange(newValue);
    }
  };

  let selectedValue;

  if (Array.isArray(formData)) {
    if (schema.options) {
      selectedValue = formData.map((value) => schema.options.find((option) => option.value === value));
      selectedValue = selectedValue.filter((value) => value !== null && typeof value !== 'undefined');
    }
  } else {
    selectedValue = schema.options ? schema.options.find((option) => option.value === formData) : null;
  }

  const inputRef = useRef();

  const onClear = () => {
    inputRef.current.select.clearValue();
    onChange(null);
  };

  return (
    <div>
      {schema.title ? <label className="control-label">{schema.title}</label> : ''}
      <Select
        ref={inputRef}
        name="form-field-name"
        value={selectedValue}
        options={schema.options}
        onChange={onValueChange}
        isMulti={schema.multi}
      />
      {schema.showClearOption ? (
        <button className="btn btn-normal-link" onClick={onClear}>
          <small>
            <FormattedMessage id={'form.custom.select.clear'} />
          </small>
        </button>
      ) : (
        ''
      )}
    </div>
  );
}

export default CustomSelect;
